import Swiper from 'swiper/bundle';
// import Swiper styles

// import Swiper styles
import 'swiper/swiper-bundle.css';

const sliders = {
    init() {
      setTimeout(function(){
          const testimonialSlider = new Swiper('.js-testimonial-slider', {
              slidesPerView: 1,
              spaceBetween: 16,
              pagination: {
                  el: '.js-testimonial-slider .swiper-pagination',
                  clickable: true, // Make pagination bullets clickable
              },
              speed: 1000,
              autoplay: {
                  delay: 6000, // Set delay between transitions in milliseconds
                  disableOnInteraction: true, // Autoplay will not be disabled after interactions

              },
              navigation: {
                  nextEl: '.js-testimonial-slider .swiper-button-next',
                  prevEl: '.js-testimonial-slider .swiper-button-prev',
              },

          });

          const servicesSlider = new Swiper('.js-services-slider', {
              slidesPerView: 1,
              spaceBetween: 16,
              navigation: {
                  nextEl: '.services-slider .swiper-button-next',
                  prevEl: '.services-slider .swiper-button-prev',
              },

          });
          var spacer = 80;
          function checkWindowSize() {
              if (window.innerWidth < 768) {
                  spacer = 40;
              }
          }
          window.addEventListener('resize', checkWindowSize);
          checkWindowSize();  // Also check when the page loads

          const logoSlider = new Swiper('.js-logo-slider', {
              slidesPerView: 'auto', // Automatically adjust the number of slides based on available space
              spaceBetween: spacer, // Space between slides
              loop: true,
              loopAdditionalSlides: 10,
              autoplay: {
                  delay: 0, // Delay between transitions in ms
                  disableOnInteraction: false, // Continue autoplay after user interaction
              },
              speed: 6000,
              preloadImages: false,
              lazy: true,
          });



         if($('.js-book-slider')[0]){
             const bookSlider = new Swiper('.js-book-slider', {
                 slidesPerView: "auto",
                 spaceBetween: 40,
                 loop: true,  // Enables continuous loop mode
                 centeredSlides: true,
                 initialSlide: 1,
                 speed: 5000,
                 autoplay: {
                     delay: 3000, // Set delay between transitions in milliseconds
                     disableOnInteraction: true, // Autoplay will not be disabled after interactions

                 },
                 on: {
                     init: function () {
                         equalizeSlideHeights();
                     },
                     resize: function () {
                         equalizeSlideHeights();
                     }
                 }
             });
         }

            if($('.js-book-slider')[0]){
                var mySwiper = document.querySelector('.js-book-slider').swiper;

                $(".book-slider .swiper-wrapper").mouseenter(function() {
                    mySwiper.autoplay.stop();
                    console.log('slider stopped');
                });

                $(".book-slider .swiper-wrapper").mouseleave(function() {
                    mySwiper.autoplay.start();
                    console.log('slider started again');
                });
            }
          function equalizeSlideHeights() {
              let maxHeight = 0;
              document.querySelectorAll('.js-book-slider .swiper-slide').forEach(function (slide) {
                  slide.style.height = 'auto'; // Reset height to compute natural height
                  const height = slide.offsetHeight;
                  if (height > maxHeight) maxHeight = height;
              });

              document.querySelectorAll('.js-book-slider .swiper-slide').forEach(function (slide) {
                  slide.style.height = maxHeight + 'px'; // Set all slides to the maximum height found
              });
          }

      }, 400)
    }
}
export {sliders}